export default {"src":"/_next/static/media/ling-logo.aea03259.svg","height":48,"width":112,"blurWidth":0,"blurHeight":0};